import { createContext, useContext } from "react";
import { COPY } from "../data/copy";

const MessagingContext = createContext(null);

// Locked to the "Original" (A) messaging for launch.
const ACTIVE_VERSION = "A";

export function MessagingProvider({ children }) {
  return (
    <MessagingContext.Provider value={{ version: ACTIVE_VERSION }}>
      {children}
    </MessagingContext.Provider>
  );
}

export function useMessaging() {
  return useContext(MessagingContext);
}

export function useCopy() {
  const ctx = useContext(MessagingContext);
  return COPY[ctx?.version || ACTIVE_VERSION];
}
